export default __webpack_public_path__ + "baby-kids.cf0841b035b866f3a444aac27f5a2888.png";